import { Component, OnInit, Input } from '@angular/core';
import { MenuItem } from '../models/menu-item.model';

@Component({
  selector: 'header-menu-item',
  templateUrl: './header-menu-item.component.html',
  styleUrls: ['./header-menu-item.component.css']
})
export class HeaderMenuItemComponent implements OnInit {

    @Input() item: MenuItem;

    isOpen = false;

    constructor() { }

    ngOnInit() {

    }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    hasChildren(item: MenuItem): boolean {
        return item.children && item.children.length > 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/header-menu-item/header-menu-item.component.ts